import React from 'react';
import {
    Alert, CircularProgress, IconButton
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const AlertMessages = ({
    isLoading,
    noPlacesFoundMessage,
    errorMessage,
    successMessage,
    onCloseAlert,
    onCloseError,
    onCloseSuccess
}) => {
    return (
        <>
            {isLoading && (
                <div style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    zIndex: 1000,
                    background: 'rgba(255, 255, 255, 0.95)',
                    backdropFilter: 'blur(8px)',
                    borderRadius: '16px',
                    padding: '24px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '16px',
                    boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
                    animation: 'fadeIn 0.3s ease-in-out'
                }}>
                    <CircularProgress
                        size={48}
                        sx={{ 
                            color: '#2563eb',
                            animation: 'pulse 2s infinite'
                        }}
                    />
                    <div style={{
                        fontSize: '0.875rem',
                        fontWeight: 500,
                        color: '#64748b',
                        textAlign: 'center'
                    }}>
                        Searching for places...
                    </div>
                </div>
            )}

            {noPlacesFoundMessage && (
                <Alert
                    severity="info"
                    sx={{
                        position: 'absolute',
                        top: '20%',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        zIndex: 1000,
                        minWidth: '300px',
                        maxWidth: '500px',
                        borderRadius: 3,
                        backdropFilter: 'blur(8px)',
                        backgroundColor: 'rgba(255, 255, 255, 0.95)',
                        border: '1px solid rgba(226, 232, 240, 0.6)',
                        animation: 'slideIn 0.3s ease-out'
                    }}
                    action={
                        <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={onCloseAlert}
                            sx={{
                                '&:hover': {
                                    backgroundColor: 'rgba(59, 130, 246, 0.1)'
                                }
                            }}>
                            <CloseIcon fontSize="inherit"/>
                        </IconButton>
                    }>
                    {noPlacesFoundMessage}
                </Alert>
            )}

            {errorMessage && (
                <Alert
                    severity="error"
                    sx={{
                        position: 'absolute',
                        top: '20%',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        zIndex: 1000,
                        minWidth: '300px',
                        maxWidth: '500px',
                        borderRadius: 3,
                        backdropFilter: 'blur(8px)',
                        backgroundColor: 'rgba(255, 255, 255, 0.95)',
                        border: '1px solid rgba(239, 68, 68, 0.3)',
                        animation: 'slideIn 0.3s ease-out'
                    }}
                    action={
                        <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={onCloseError}
                            sx={{
                                '&:hover': {
                                    backgroundColor: 'rgba(239, 68, 68, 0.1)'
                                }
                            }}>
                            <CloseIcon fontSize="inherit"/>
                        </IconButton>
                    }>
                    {errorMessage}
                </Alert>
            )}

            {successMessage && (
                <Alert
                    severity="success"
                    sx={{
                        position: 'absolute',
                        top: '20%',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        zIndex: 1000,
                        minWidth: '300px',
                        maxWidth: '500px',
                        borderRadius: 3,
                        backdropFilter: 'blur(8px)',
                        backgroundColor: 'rgba(255, 255, 255, 0.95)',
                        border: '1px solid rgba(16, 185, 129, 0.3)',
                        animation: 'slideIn 0.3s ease-out'
                    }}
                    action={
                        <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={onCloseSuccess}
                            sx={{
                                '&:hover': {
                                    backgroundColor: 'rgba(16, 185, 129, 0.1)'
                                }
                            }}>
                            <CloseIcon fontSize="inherit"/>
                        </IconButton>
                    }>
                    {successMessage}
                </Alert>
            )}
        </>
    );
};

export default AlertMessages;